import UserRegister from "./UserRegister";

function UserRegisterFn(data){

    let thisObj = new UserRegister();
    thisObj.eventFunction(data);

}

export default UserRegisterFn;